import React from 'react'

const NavBar = () => {
  return (
    <nav className="navbar">
        <div className="container">
            <a className="navbar-brand" href="/">
                <img src="https://firebasestorage.googleapis.com/v0/b/lapalmeraweb.appspot.com/o/La%20Palmera-01.png?alt=media&token=8ba273e0-6cba-4a38-b89f-eb476b357536" alt="" height="100rem" />
            </a>
            <h3>Menú del café.</h3>
        </div>
    </nav>
  )
}

export default NavBar
